module.exports = __webpack_public_path__ + "static/img/renzheng_logo.825a164.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/renzheng_logo.png
// module id = uqc4
// module chunks = 1